import React from "react";
import { Button } from "./ui/Button";
import { useNavigate } from "react-router-dom";

export function Hero() {
  const navigate = useNavigate();
  return (
    <section className="relative bg-gradient-to-r from-blue-50 to-indigo-50 pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12">
          <div className="w-full md:Fw-1/2 space-y-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Votre <span className="text-blue-600">partenaire</span> pour le
              recrutement temporaire et permanent
            </h1>
            <p className="text-lg text-gray-700 max-w-xl">
              J'M Intérim vous accompagne dans vos recherches d'emploi et de
              personnel qualifié depuis plus de 15 ans avec expertise et
              bienveillance.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white"
                onClick={() => navigate("/offres-emploi")}
              >
                Je cherche un emploi
              </Button>

              <Button
                size="lg"
                variant="outline"
                className="border-blue-600 text-blue-600 hover:bg-blue-50"
                onClick={() => navigate("/devenir-client")}
              >
                Je recrute
              </Button>
            </div>
          </div>

          <div className="w-full md:w-2/3 relative">
            <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
                alt="Équipe J'M Intérim"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-blue-100 rounded-full opacity-50 -z-10"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-indigo-100 rounded-full opacity-50 -z-10"></div>
          </div>
        </div>
      </div>

      <div
        className="absolute bottom-0 left-0 right-0 h-20 bg-white"
        style={{ clipPath: "polygon(0 100%, 100% 100%, 100% 0)" }}
      ></div>
    </section>
  );
}
